import React from 'react';


const ContentTitle = ({ title }) => (
  <h6 className="m-5 text-dark-gray">
    {title}
  </h6>
);

export default ContentTitle;
